import { Client } from "@/Common/Api/Client";
import { FileType } from "@/Common/Models/FileType";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseGetExportableFileFetchUrlResponse } from "../BaseGetExportableFileFetchUrlResponse";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";
import { GenerateFileOptions } from "../IGenerateFileOptions";
import { FileTypeTemporaryFile } from "./FileTypeTemporaryFile";

interface IFileTypeEncounter extends IExportableFile {
    EncounterId: string;
}

class FileTypeEncounter extends ExportableFile implements IFileTypeEncounter {
    public canGenerateFileXcom: boolean = true;

    public EncounterId: string;

    constructor(fields: IFileTypeEncounter) {
        super(FileType.ENCOUNTER);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.EncounterId; }

    public getCleanCopy(): FileTypeEncounter {
        let copyConstructor: IFileTypeEncounter = {
            EncounterId: this.EncounterId,
            date: this.date,
            description: this.description
        };

        return new FileTypeEncounter(copyConstructor);
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected async generateFileIfNeededXcom(includeOverlays: boolean): Promise<IExportableFileLoaded> {
        return await this.generateFileIfNeeded({ includeOverlays: includeOverlays, isExternal: true });
    }

    protected async generateFileIfNeeded(generateFileOption: GenerateFileOptions): Promise<IExportableFileLoaded> {
        const { includeOverlays, isExternal } = generateFileOption;
        const requestedOverlays = (includeOverlays && this.overlayElements) || [];

        const response =
            isExternal
                ? await Client.postAsyncXcom<BaseGetExportableFileFetchUrlResponse>(
                    ServerOperations.Server.ExportableFile_GetMedicalNoteFetchUrl,
                    {
                        OverlayElements: this.serializeOverlayElements(),
                        EncounterId: this.EncounterId,
                        IncludeRadpdfForms: false
                    },
                    this.clientTag,
                    this.claimId
                )
                : await Client.postAsync<BaseGetExportableFileFetchUrlResponse>(
                    ServerOperations.Server.ExportableFile_GetMedicalNoteFetchUrl,
                    {
                        OverlayElements: this.serializeOverlayElements(),
                        EncounterId: this.EncounterId,
                        IncludeRadpdfForms: false
                    }
                );

        if (!response.isSuccess)
            return;

        this.totalPages = response.data.TotalPages;

        const tempFile = new FileTypeTemporaryFile({
            ObjectId: response.data.ObjectId,
            totalPages: this.totalPages,
            sizeBytes: response.data.SizeBytes,
            date: this.date,
            description: this.description
        });

        // add external file properties
        tempFile.isExternal = isExternal;
        if (tempFile.isExternal) {
            tempFile.clientTag = this.clientTag;
            tempFile.claimId = this.claimId;
        }

        super.setCache(tempFile, requestedOverlays);

        return {
            OriginalExportableFile: this,
            PregeneratedTemporaryFile: tempFile,
            FetchUrl:
                isExternal
                    ? tempFile.FetchUrlXcom(this.clientTag, this.claimId)
                    : tempFile.FetchUrl
        } as IExportableFileLoaded;
    }
}

export { FileTypeEncounter };
